import React from 'react'
import Link from 'gatsby-link'

const QuienesSomos = () => (
  <div>
    <h1>¿Qué es Gasred?</h1>
    <p>
      Sistema de monedero electrónico autorizado por el SAT que permite
      administra y controlar el consumo de combustible.
    </p>
    <h2>Visión</h2>
    <p>
      Empresa líder en el noroeste del país, en sistemas de control del
      combustible.
    </p>
    <h2>Misión</h2>
    <p>
      Elevarla productividad en el consumo de combustible, a través de sistemas
      de control eficiente, satisfaciendo las más altas expectativas de nuestros
      clientes, colaboradores y accionistas.
    </p>
    <h2>Valores</h2>
    <ul>
      <li>Disponibilidad</li>
      <li>Mejora continua</li> <li>Empatía </li> <li>Trabajo en equipo </li>
      <li>Servicio Responsabilidad</li>
    </ul>
  </div>
)

export default QuienesSomos



// WEBPACK FOOTER //
// ./src/pages/quienes-somos.js